export default __webpack_public_path__ + "static/media/white_logo.a9315e09.png";